export enum Locale {
  EnUs = 'en-us',
  EnCa = 'en-ca',
  FrCa = 'fr-ca',
}
